import { render, staticRenderFns } from "./SimDetailCard.vue?vue&type=template&id=82d7b8ea&"
import script from "./SimDetailCard.vue?vue&type=script&lang=js&"
export * from "./SimDetailCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports